import { ModalInput } from "components/atoms/input/modal/ModalInput";
import { Text } from "components/atoms/text/Text";
import { COLORS } from "styles/colors";
import SelectComponent from "components/atoms/select/SelectComponent";
import styled from "styled-components";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { SUBSCRIPTION_TYPE } from "api/interfaces/subscription.interface";
import { useKeyType } from "hook/subscription/useKeyType";
import { CommonWrapper, Title } from "pages/subscription/SubscriptionStyled";

type Props = {
  keyType: SUBSCRIPTION_TYPE | undefined;
  onChangeType: (value: SUBSCRIPTION_TYPE) => void;
};

export default function KeyType(props: Props): JSX.Element {
  const { accountLevel }: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  const { keyTypeOptions, getServiceData } = useKeyType();

  return (
    <CommonWrapper>
      <Title>
        <Text style={{ whiteSpace: "break-spaces" }} fontSize={18} bold>
          Select the type of the subscription keys to request.
        </Text>
      </Title>
      <ModalInput label="Subscripton Type" essential>
        <SelectComponent
          placeholder="Select a service"
          options={keyTypeOptions}
          value={keyTypeOptions.find((opt) => opt.value === props.keyType)}
          onChange={(value) => props.onChangeType(value as SUBSCRIPTION_TYPE)}
          loading={getServiceData.isFetching}
          data-testid="subscription-modal-common-selects-change-type"
        />

        <Description color={COLORS.BUTTONS1} fontSize={15}>
          {accountLevel !== LEVEL_TYPE.EU &&
            `
                  Select the type of key you’d like to create. Additional details about the keys you want to generate must be filled out in the next step.
                  `}
        </Description>
      </ModalInput>
    </CommonWrapper>
  );
}

const Description = styled(Text)`
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  padding-top: 6px;
`;
